import { render, staticRenderFns } from "./ElectronicDocuments.vue?vue&type=template&id=b5f985ac"
import script from "./ElectronicDocuments.vue?vue&type=script&lang=js"
export * from "./ElectronicDocuments.vue?vue&type=script&lang=js"
import style0 from "./ElectronicDocuments.vue?vue&type=style&index=0&id=b5f985ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports